import { useEffect } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useRiskRegisterStore } from 'store/riskRegister.store';
import { useThemeStatusStore } from 'store/themeStatus.store';

import { useDistributionGraphProvider } from 'components/widgets/DistributionGraph/DistributionGraph.provider';
import {
    exportCsvHeaders,
    serializeData,
    serializeOptions,
} from 'components/widgets/DistributionGraph/DistributionGraph.utils';

interface Props {
    api: ReturnType<typeof useDistributionGraphProvider>['api'];
}

export const useDistributionGraphLogic = ({ api }: Props) => {
    const { themeStatus } = useThemeStatusStore();
    const { handleSnackBar } = useCustomSnackBar();
    const { update, numOfIterations, taskVersionLabel } = useRiskRegisterStore();
    const data = api.getDistributionGraph.data;
    const series = data ? serializeData(data) : [];
    const options = data
        ? serializeOptions({
              data,
              themeStatus,
          })
        : {};

    useEffect(() => {
        if (api.getDistributionGraph.data) {
            update({ isRunningQsra: false });
        }
    }, [api.getDistributionGraph.data]);

    useEffect(() => {
        if (api.getDistributionGraph.isError) {
            update({ activeTab: 'table' });
            DEFAULT_ERROR({ error: api.getDistributionGraph.error, handleError: handleSnackBar });
        }
    }, [api.getDistributionGraph.isError, api.getDistributionGraph.error]);

    return {
        logic: {
            series,
            options,
            numOfIterations,
            taskVersionLabel,
            exportCsv: {
                headers: exportCsvHeaders,
                rows: api.getDistributionGraph.data?.barSeries.data.map((row, index) => ({
                    date: moment(row.label).format(constants.formats.date.default),
                    frequencyCount: api.getDistributionGraph.data?.barSeries.data[index].value,
                    percentOfProbability: api.getDistributionGraph.data?.lineSeries.data[index].value,
                })),
                fileName: 'Distribution-Chart',
            },
        },
    };
};
